import { render, staticRenderFns } from "./crmActivities.vue?vue&type=template&id=0c36a1ae"
import script from "./crmActivities.vue?vue&type=script&lang=js"
export * from "./crmActivities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports